import * as googleActionTypes from './googleActionTypes';

export const setGoogleLoaded = () => ({ type: googleActionTypes.GOOGLE_LOADED });